import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service_type: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({
      ...prev,
      service_type: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name || !formData.email || !formData.phone || !formData.service_type || !formData.message) {
      toast.error('Por favor completa todos los campos');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.status === 200) {
        toast.success('¡Mensaje enviado exitosamente! Te responderemos pronto.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          service_type: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Error submitting contact:', error);
      toast.error('Hubo un error al enviar tu mensaje. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="w-full max-w-2xl mx-auto shadow-xl border-none">
      <CardHeader className="bg-gradient-to-r from-[#1565c0]/5 to-[#00c853]/5">
        <CardTitle className="text-2xl text-[#0d1b2a]">Escríbenos</CardTitle>
        <CardDescription className="text-base">
          ¿Tienes alguna pregunta? Completa el formulario y te responderemos pronto
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid md:grid-cols-2 gap-5">
            <div className="space-y-2">
              <Label htmlFor="contact-name" className="text-[#0d1b2a] font-medium">
                Nombre Completo <span className="text-red-500">*</span>
              </Label>
              <Input
                id="contact-name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Tu nombre"
                required
                className="border-gray-300 focus:border-[#1565c0] focus:ring-[#1565c0]"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="contact-phone" className="text-[#0d1b2a] font-medium">
                Teléfono <span className="text-red-500">*</span>
              </Label>
              <Input
                id="contact-phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="3001234567"
                required
                className="border-gray-300 focus:border-[#1565c0] focus:ring-[#1565c0]"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="contact-email" className="text-[#0d1b2a] font-medium">
              Correo Electrónico <span className="text-red-500">*</span>
            </Label>
            <Input
              id="contact-email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="correo@ejemplo.com"
              required
              className="border-gray-300 focus:border-[#1565c0] focus:ring-[#1565c0]"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="contact-service" className="text-[#0d1b2a] font-medium">
              ¿En qué estás interesado? <span className="text-red-500">*</span>
            </Label>
            <Select 
              value={formData.service_type} 
              onValueChange={handleSelectChange}
              required
            >
              <SelectTrigger className="border-gray-300 focus:border-[#1565c0] focus:ring-[#1565c0]">
                <SelectValue placeholder="Selecciona una opción" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="seguros">Seguros</SelectItem>
                <SelectItem value="creditos">Créditos</SelectItem>
                <SelectItem value="ambos">Seguros y Créditos</SelectItem>
                <SelectItem value="consulta">Consulta General</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="contact-message" className="text-[#0d1b2a] font-medium">
              Mensaje <span className="text-red-500">*</span>
            </Label>
            <Textarea
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Escribe tu mensaje aquí..."
              rows={4}
              required
              className="border-gray-300 focus:border-[#1565c0] focus:ring-[#1565c0] resize-none"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-[#1565c0] to-[#00c853] hover:from-[#1e88e5] hover:to-[#43a047] text-white py-6 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            {loading ? 'Enviando...' : 'Enviar Mensaje'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default ContactForm;
